export async function asyncForEach<T, U>(arr: T[], cb: (d: T, i: number, arr: T[]) => Promise<U>) {
  for (let i = 0; i < arr.length; i++) {
    await cb(arr[i], i, arr);
  }
}

export async function sequentialMap<T, U>(arr: T[], cb: (d: T, i: number, arr: T[]) => Promise<U>): Promise<U[]> {
  let out = [];
  for (let i = 0; i < arr.length; i++) {
    out.push(await cb(arr[i], i, arr));
  }
  return out;
}

export async function sequentialMapEvery<T>(arr: T[], cb: (d: T, i: number, arr: T[]) => Promise<boolean>): Promise<boolean> {
  for (let i = 0; i < arr.length; i++) {
    if (!await cb(arr[i], i, arr)) {
      return false;
    }
  }
  return true;
}